export default __webpack_public_path__ + "static/media/mens.99721184.svg";